<template>
  <div>
    <h1>External</h1>
    <div v-if="objectList">
      <form method="post" @submit.prevent="filterObjects()">
        <div class="row">
          <div class="col-md-3 mb-3">
            <v-date-picker
              v-model="formData.start_date"
              label="Start Date"
              :translate-text="false"
            />
          </div>
          <div class="col-md-3 mb-3">
            <v-date-picker
              v-model="formData.end_date"
              label="End Date"
              :translate-text="false"
            />
          </div>
          <div class="col-md-3 mb-3">
            <v-text-input
              label="Research Set"
              placeholder="UUID"
              v-model="formData.researchSetUUID"
            />
          </div>

          <div class="col-md-3 mb-3 d-flex align-items-end">
            <v-button
              type="submit"
              icon="filter"
              :text="`Filter (${objectList.length})`"
              :block="true"
              :translate-text="false"
            />
          </div>
        </div>
      </form>

      <table class="table">
        <thead>
        <tr>
          <td><strong>{{ $t('word.timestamp') }}</strong></td>
          <td><strong>Review Session UUID</strong></td>
          <td class="d-flex flex-nowrap">
            <strong>User Identifier</strong>
            <v-button
              :icon="copied ? 'check' : 'copy'"
              style-type="link"
              :disabled="copied"
              size="xs"
              @click="copyIdentifierToClipboard()"
            />
          </td>
          <td><strong>RSID</strong></td>
          <td><strong>UUID</strong></td>
          <td><strong>External Party Slug</strong></td>
        </tr>
        </thead>

        <tbody>
        <tr
          :style="{'text-decoration': !session.is_active ? 'line-through' : 'none'}"
          v-for="session in objectList" :key="session.timestamp">
          <td>
            {{stringToPrettyDateTime(session.timestamp)}}
          </td
            >
          <td>{{session.session_uuid}}</td>
          <td>{{session.user_identifier_value}}</td>
          <td>{{session.theme_identifier_value || session.research_set_identifier_value }}</td>
          <td>{{session.theme_slug || session.research_set_uuid }}</td>
          <td>{{session.external_party_slug}}</td>
          <td>
            <v-button
              v-if="session.is_active"
              size="xs"
              style-type="danger"
              icon="trash"
              @click="toggleObjectActive(session)"
            />
            <v-button
              v-else
              size="xs"
              style-type="secondary"
              icon="undo"
              @click="toggleObjectActive(session)"
            />
          </td>
        </tr>
        </tbody>
      </table>

    </div>
    <v-loader
      v-if="loading"
    />
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Loader from '@/common/components/Loader.vue';
import DatePicker from '@/common/components/inputs/DatePicker.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import { GenericListMixin } from '@/common/utils/mixins';
import { stringToPrettyDateTime, toFormattedDate } from '@/common/utils/formatting';
import { updateExternalPartySession } from '@/admin/api';


export default {
  name: 'ExternalDashboard',
  mixins: [
    GenericListMixin,
  ],
  components: {
    'v-button': Button,
    'v-date-picker': DatePicker,
    'v-loader': Loader,
    'v-text-input': TextInput,
  },
  methods: {
    stringToPrettyDateTime,
    async toggleObjectActive(session) {
      // eslint-disable-next-line no-underscore-dangle
      const response = await updateExternalPartySession(session._id, !session.is_active);
      if (response.status === 200) {
        this.getObjects();
      }
    },
    getParams() {
      return {
        start_date: toFormattedDate(this.formData.start_date),
        end_date: toFormattedDate(this.formData.end_date),
        research_set_uuid: this.formData.researchSetUUID,
      };
    },
    copyIdentifierToClipboard() {
      const identifiers = this.objectList
        .filter((session) => session.is_active)
        .map((session) => session.user_identifier_value);
      const text = [...new Set(identifiers)].join('\n');
      navigator.clipboard.writeText(text).then(() => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 1000);
      }, (err) => {
        console.error('Async: Could not copy text: ', err);
      });
    },
  },
  data() {
    return {
      apiPath: 'admin/external-party-sessions/',
      formData: {
        start_date: null,
        end_date: new Date(),
        researchSetUUID: '',
      },
      copied: false,
    };
  },
  created() {
    const now = new Date();
    this.formData.start_date = new Date(now.getFullYear(), now.getMonth(), 1);
  },
};
</script>
